import { genericColors } from './genericColors';

export const darkTheme = {
  genericColors: { ...genericColors },
  themeColors: {
    controlBar: {
      background: genericColors.grayDove,
      borderBottomColor: genericColors.grayDark,
      leftPanel: {
        goBackButtonColor: genericColors.grayLight,
        goBackButtonColorOnHover: genericColors.blueSoft,
        goBackButtonColorOnActive: genericColors.blueMain,
        dividerColor: genericColors.gray,
        buttonColor: genericColors.grayDim,
        buttonColorOnHover: genericColors.blueSoft,
        buttonColorOnActive: genericColors.blueBondi,
      },
      rightPanel: {
        icons: {
          bookmarkIcon: {
            colorOnEmpty: 'rgba(252, 122, 30, 0.7)',
            colorOnEmptyAndHover: genericColors.orangeMain,
            colorOnFilled: genericColors.orangeZest,
            colorOnFilledAndHover: genericColors.orangeSandy,
          },
          bookshelfIcon: {
            booksIconColor: genericColors.grayLight,
            booksIconColorOnHover: genericColors.blueBondi,
            circleBackground: genericColors.grayDove,
            iconColor: genericColors.blueSeagull,
            iconColorOnActive: genericColors.blueBondi,
          },
          settingsIcon: {
            color: genericColors.grayDim,
            colorOnHover: genericColors.blueBondi,
            colorOnActive: genericColors.blueBondi,
          },
          searchIcon: {
            color: genericColors.grayDim,
            colorOnHover: genericColors.blueBondi,
            colorOnActive: genericColors.blueBondi,
          },
        },
      },
    },
    settingsDropdown: {
      background: genericColors.grayDove,
      borderColor: genericColors.grayDark,
      boxShadow: '0px 1px 10px rgba(96, 96, 96, 0.8)',
      dividerColor: genericColors.grayBoulder,
      textColor: genericColors.grayDim,
      pageModeTogglerBorder: genericColors.gray,
      pageModeTogglerColor: genericColors.gray,
      oldReaderLinkColor: genericColors.blueSeagull,
      oldReaderLinkColorOnHover: genericColors.blueBondi,
    },
    sidebars: {
      background: 'rgba(79, 79, 79, 0.98)',
      toc: {
        textColor: genericColors.grayLight,
        subTextColor: genericColors.gray,
        dividerColor: genericColors.grayBoulder,
        itemColor: genericColors.white,
        itemColorOnHover: genericColors.blueBright,
        itemColorOnActive: genericColors.blackTotal,
        itemBackgroundOnActive: 'rgba(235, 235, 235, 0.5)',
      },
      thumbnails: {
        textColor: genericColors.white,
        textColorOnActive: genericColors.grayLight,
      },
      bookmarks: {
        headerBackground: 'rgba(235, 235, 235, 0.5)',
        pagesColor: genericColors.blueBondi,
        textColor: genericColors.white,
        dateColor: genericColors.grayLight,
        removeColor: genericColors.orangePeachy,
        dividerColor: genericColors.grayBoulder,
      },
    },
    pageContainer: { background: genericColors.blackMineShaft },
    footer: {
      background: genericColors.blackMineShaft,
      textColor: genericColors.white,
      progressBar: {
        trackColor: genericColors.grayBoulder,
      },
    },
    arrowButtons: {
      color: genericColors.gray,
      dropShadow: 'drop-shadow(6px 2px 6px #000000)',
    },
    zoomButtons: {
      background: 'rgba(124, 124, 124, 0.95)',
      backgroundOnHover: genericColors.grayBoulder,
      backgroundOnActive: genericColors.grayDove,
      borderColor: 'rgba(124, 124, 124, 0.95)',
      borderColorOnHover: genericColors.grayBoulder,
      borderColorOnActive: genericColors.grayDove,
      boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.8)',
      boxShadowOnHover: '0px 3px 8px rgba(0, 0, 0, 0.8)',
      iconColor: genericColors.grayLight,
      iconColorOnHover: genericColors.orangeSoft,
      iconColorOnActive: genericColors.orangeSoft,
    },
    beta: {
      button: {
        background: genericColors.grayBoulder,
        backgroundOnHover: genericColors.grayLight,
        backgroundOnActive: genericColors.gray,
        border: 'transparent',
        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
        iconColor: genericColors.grayLight,
        iconColorOnHover: genericColors.orangeZest,
        iconColorOnActive: genericColors.orangeZest,
      },
      modal: {
        background: genericColors.grayLight,
        borderColor: genericColors.gray,
        textColor: genericColors.blackTotal,
        smallTextColor: genericColors.grayDark,
        buttonBackground: 'rgba(251, 151, 59, 0.7)',
      },
    },
  },
  fontSizes: {
    base: '1rem',
    small: '0.88875rem',
    tiny: '0.79rem',
  },
  backgroundTransitionTime: '0.25s',
};
